// Sale-message countdown. Activates only when the block's data-end-date is set
// to a valid ISO timestamp and the sale ends within 48 hours.
(function () {
  const TWO_DAYS_MS = 48 * 60 * 60 * 1000;

  function formatRemaining(ms) {
    if (ms <= 0) return null;
    const totalMinutes = Math.floor(ms / 60000);
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  }

  function tick(el) {
    const endIso = el.dataset.endDate;
    if (!endIso) return;

    const endTs = Date.parse(endIso);
    if (Number.isNaN(endTs)) return;

    const remaining = endTs - Date.now();
    const baseText = el.dataset.baseText || '';
    const prefix = el.dataset.countdownPrefix || 'Hurry — sale ends in';

    if (remaining <= 0) {
      el.textContent = baseText;
      return;
    }

    if (remaining > TWO_DAYS_MS) {
      // Outside countdown window — show the static merchant message
      el.textContent = baseText;
      return;
    }

    const formatted = formatRemaining(remaining);
    el.textContent = `${prefix} ${formatted}`;
  }

  function init() {
    const targets = document.querySelectorAll('[data-sale-message-text]');
    targets.forEach((el) => {
      tick(el);
      // Refresh every 30s so days/hours/minutes stay accurate without burning CPU.
      setInterval(() => tick(el), 30000);
    });

    randomizeSocialProof();
  }

  function randomizeSocialProof() {
    const lines = document.querySelectorAll('[data-social-proof-line]');
    lines.forEach((line) => {
      if (line.dataset.randomize === 'false') return;
      const min = parseInt(line.dataset.min, 10);
      const max = parseInt(line.dataset.max, 10);
      const template = line.dataset.template || '';
      const textEl = line.querySelector('[data-social-proof-text]');
      if (!textEl || Number.isNaN(min) || Number.isNaN(max) || max < min) return;

      const count = Math.floor(Math.random() * (max - min + 1)) + min;

      let rendered;
      if (template.indexOf('{{ count }}') !== -1) {
        rendered = template.split('{{ count }}').join(count);
      } else {
        // Backwards compat: replace the first run of digits in the template.
        rendered = template.replace(/\d+/, count);
      }
      textEl.textContent = rendered;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
